import { SITE_URL, SITE_NAME } from './Seo.jsx';

// Site-wide Organization schema — reused on every page so Google has one
// consistent entity to attach reviews, sitelinks, and the knowledge panel to.
export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  contactPoint: [
    {
      '@type': 'ContactPoint',
      contactType: 'sales',
      url: `${SITE_URL}/#ContactUs`,
      availableLanguage: ['English'],
    },
  ],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  publisher: { '@id': `${SITE_URL}/#organization` },
};

// One Service entry per offering shown on the homepage (Consulting/GenAI/etc.)
export const serviceSchema = (name, description) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  provider: { '@id': `${SITE_URL}/#organization` },
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path === '/' ? '' : item.path}`,
  })),
});
